export default __webpack_public_path__ + "static/media/Spiritual Ring.96f298d4.jpg";